import { render, staticRenderFns } from "./InventoryPolicy.vue?vue&type=template&id=258630b8"
import script from "./InventoryPolicy.vue?vue&type=script&lang=js"
export * from "./InventoryPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports